'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AIR = exports.AIR = 'TQ_PLUS/AIR';
var CAR = exports.CAR = 'TQ_PLUS/CAR';
var HOTEL = exports.HOTEL = 'TQ_PLUS/HOTEL';
var CONTAINER = exports.CONTAINER = 'TQ_PLUS/CONTAINER';
var CONTAINER_NO_PROPS = exports.CONTAINER_NO_PROPS = 'TQ_PLUS/CONTAINER_NO_PROPS';
var INPUT_TEXT = exports.INPUT_TEXT = 'TQ_PLUS/INPUT_TEXT';
var TEXTAREA = exports.TEXTAREA = 'TQ_PLUS/TEXTAREA';
var LABEL = exports.LABEL = 'TQ_PLUS/LABEL';
var TABS = exports.TABS = 'TQ_PLUS/TABS';


//////////////////
// WEBPACK FOOTER
// ./src/constants/templateComponentTypes.js
// module id = 662
// module chunks = 0